import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import useGoToPricing from "../../hooks/useGoToPricing";
import { isLoggedIn } from "../../utils/isLoggedIn";
import Header from "../Homepage/sections/Header";
import Footer from "../Homepage/sections/Footer";
import { Page, HomepageGlobalStyles } from "../Homepage/styles";
import FaqAccordion from "./FaqAccordion";
import { FAQ_SECTIONS, FAQ_TERMS_LINKS } from "./faqContent";
import {
  FaqContent,
  FaqContentInner,
  FaqSectionBlock,
  FaqSectionTitle,
  FaqTermsList,
  FaqTermsLink,
  FaqCta,
  FaqCtaBg,
  FaqCtaInner,
  FaqCtaTitle,
  FaqCtaLead,
  FaqCtaButton,
} from "./Faq.styles";

const Faq = () => {
  const goToPricing = useGoToPricing();
  const loggedIn = isLoggedIn();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <Page>
      <HomepageGlobalStyles />
      <Header onSubscribeClick={goToPricing} hideSpacer />

      <FaqContent>
        <FaqContentInner>
          {FAQ_SECTIONS.map((section) => (
            <FaqSectionBlock key={section.title}>
              <FaqSectionTitle>
                <span>{section.title}</span>
              </FaqSectionTitle>
              <FaqAccordion
                sectionId={section.title.replace(/\s+/g, "-").toLowerCase()}
                items={section.items}
              />
            </FaqSectionBlock>
          ))}

          <FaqSectionBlock>
            <FaqSectionTitle>
              <span>Terms &amp; Conditions</span>
            </FaqSectionTitle>
            <FaqTermsList>
              {FAQ_TERMS_LINKS.map((link) => (
                <li key={link.to}>
                  <FaqTermsLink as={Link} to={link.to}>
                    {link.label}
                  </FaqTermsLink>
                </li>
              ))}
            </FaqTermsList>
          </FaqSectionBlock>
        </FaqContentInner>
      </FaqContent>

      {!loggedIn && (
        <FaqCta>
          <FaqCtaBg aria-hidden="true" />
          <FaqCtaInner>
            <FaqCtaTitle>
              Still have <span>questions</span>?
            </FaqCtaTitle>
            <FaqCtaLead>
              Join thousands of members already learning from our world-class
              analysts.
            </FaqCtaLead>
            <FaqCtaButton type="button" onClick={goToPricing}>
              Start Your Subscription
            </FaqCtaButton>
          </FaqCtaInner>
        </FaqCta>
      )}

      <Footer onSubscribeClick={goToPricing} hideSubscribeCta={loggedIn} />
    </Page>
  );
};

export default Faq;
